import React from 'react';
import ListContainer from './Info/ListContainer';

const CharactersList: React.FC = () => {
  return <ListContainer />;
};

export default CharactersList;
